<div class="ui basic segment" [class.loading]="isLoading">
    <iframe *ngIf="url" id="payroll" [attr.src]="url" (load)="iframeLoaded()"></iframe>
</div>
